import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from '../styles/theme';
import { menuData } from '../data/menuData';
import { Language } from '../types';

const NavContainer = styled.div`
  position: sticky;
  top: 90px;
  background: ${theme.colors.surface};
  border-radius: ${theme.shape.borderRadius}px;
  padding: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(3)};
  box-shadow: ${theme.elevation[2]};
  z-index: 50;

  @media (max-width: ${theme.breakpoints.mobile}) {
    top: 80px;
    padding: ${theme.spacing(1)};
  }
`;

const NavTitle = styled.div`
  font-size: ${theme.typography.overline.fontSize};
  font-weight: ${theme.typography.overline.fontWeight};
  color: ${theme.colors.onSurfaceVariant};
  margin-bottom: ${theme.spacing(1)};
  text-transform: ${theme.typography.overline.textTransform};
  letter-spacing: ${theme.typography.overline.letterSpacing};
`;

const NavGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: ${theme.spacing(1)};

  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const NavButton = styled.button`
  background: ${theme.colors.surfaceVariant};
  border: none;
  border-radius: ${theme.shape.borderRadius}px;
  padding: ${theme.spacing(1)};
  font-size: ${theme.typography.caption.fontSize};
  font-weight: ${theme.typography.caption.fontWeight};
  color: ${theme.colors.onSurfaceVariant};
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;

  &:hover {
    background: ${theme.colors.primary};
    color: ${theme.colors.onPrimary};
    box-shadow: ${theme.elevation[2]};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.caption.fontSize};
    padding: ${theme.spacing(0.5)};
  }
`;

interface QuickNavProps {
  language: Language;
}

const QuickNav: React.FC<QuickNavProps> = ({ language }) => {
  const { t } = useTranslation();

  const scrollToCategory = (categoryId: string) => {
    const element = document.getElementById(categoryId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <NavContainer>
      <NavTitle>{t('quickNavigation')}</NavTitle>
      <NavGrid>
        {menuData.map(category => (
          <NavButton
            key={category.id}
            onClick={() => scrollToCategory(category.id)}
          >
            {category.name[language]}
          </NavButton>
        ))}
      </NavGrid>
    </NavContainer>
  );
};

export default QuickNav;